var _rect, _path, _path2, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.69922,
    y: 2.03638,
    width: 13,
    height: 17.6967,
    fill: "#888888"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 8.7146H15.2554",
    stroke: "white",
    strokeWidth: 0.802469
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 5.0415H15.2554",
    stroke: "white",
    strokeWidth: 0.802469
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 16.5613H15.2554",
    stroke: "white",
    strokeWidth: 0.802469
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 12.7212H15.2554",
    stroke: "white",
    strokeWidth: 0.802469
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82227,
    y: 15.5593,
    width: 1.92593,
    height: 2.0034,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82227,
    y: 11.7195,
    width: 1.92593,
    height: 2.0034,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82227,
    y: 7.71289,
    width: 1.92593,
    height: 2.0034,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4.82227,
    y: 4.03979,
    width: 1.92593,
    height: 2.0034,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 15.9534L5.59456 16.8951L5.16024 16.4243",
    stroke: "#888888",
    strokeWidth: 0.350069
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 12.1135L5.59456 13.0553L5.16024 12.5844",
    stroke: "#888888",
    strokeWidth: 0.350069
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 8.10645L5.59456 9.04822L5.16024 8.57733",
    stroke: "#888888",
    strokeWidth: 0.350069
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42773 4.43359L5.59456 5.37536L5.16024 4.90448",
    stroke: "#888888",
    strokeWidth: 0.350069
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14453 1.00242C5.14453 0.559229 5.50381 0.199951 5.947 0.199951H13.6507C14.0939 0.199951 14.4532 0.559229 14.4532 1.00242V1.53555H5.14453V1.00242Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureGroups);
export default __webpack_public_path__ + "static/media/featureGroups.e3b04512f70e0188dea17e5f9adc278e.svg";
export { ForwardRef as ReactComponent };